document.querySelectorAll(".mega-menu-left .child-item").forEach((item) => {
  item.addEventListener("mouseenter", function () {
    const index = this.dataset.index;
    const grandchildGroups =
      this.closest(".mega-menu").querySelectorAll(".grandchild-group");

    grandchildGroups.forEach((group) => {
      group.classList.remove("active");
      if (group.dataset.index === index) {
        group.classList.add("active");
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const allMegaMenus = Array.from(document.querySelectorAll(".mega-menu"));

  allMegaMenus.forEach((menu) => {
    // Temporarily show for measurement
    menu.style.visibility = "hidden";
    menu.style.display = "block";

    const left = menu.querySelector(".mega-menu-left");
    const right = menu.querySelector(".mega-menu-right");

    // --- Individual Height Calculation ---
    const menuHeight = menu.getBoundingClientRect().height;
    menu.style.height = `${menuHeight}px`;

    // --- Conditional Width Calculation (for mega-menus with grandchildren) ---
    if (right && right.children.length > 0) {
      // Measure the width of all mega-menu-left sections and get the max width
      let maxLeftWidth = 0;
      if (left) {
        // If there's more than one mega-menu-left section, we need to check them all
        Array.from(left.children).forEach((child) => {
          const childWidth = child.getBoundingClientRect().width;
          if (childWidth > maxLeftWidth) maxLeftWidth = childWidth;
        });
      }

      // Find the max width of all grandchild groups in the mega-menu-right
      let maxRightWidth = 0;
      Array.from(right.children).forEach((group) => {
        const originalDisplay = group.style.display;
        group.style.display = "block";
        const groupWidth = group.getBoundingClientRect().width;
        if (groupWidth > maxRightWidth) maxRightWidth = groupWidth;
        group.style.display = originalDisplay;
      });

      // Set the total width as the combined max width of both left and right sections
      menu.style.width = `${maxLeftWidth + maxRightWidth + 70}px`;
    }

    // Restore visibility/display
    menu.style.visibility = "";
    menu.style.display = "";
  });
});
